<template>
  <v-container fluid>
    <v-dialog v-model="progress" max-width="300px" hide-overlay persistent>
      <v-card color="primary" dark>
        <v-card-text>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-toolbar dense>
      <v-icon @click="goBack">chevron_left</v-icon>
      <v-btn @click="generatePDFs">PDF</v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title>Active Fermentation Protocols ({{total}})</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click="sendFermProtocols()">GENERATE WORKORDERS</v-btn>
      </v-toolbar>
      <br>
      <v-tabs
        v-model='active'>
        <v-tab
          v-for="n in theClients"
          :key="n"
        >
        {{ n }} ({{data[n].length}})
        </v-tab>
        <v-tab-item
          :transition="false"
          :reverse-transition="false"
          v-for="n in theClients"
          :key="n"
        >
          <table width="100%">
            <tr>
              <th>ID</th>
              <th>LotNumber</th>
              <th>Vessel</th>
              <th>Dry Ice</th>
              <th>Brix/Temp</th>
              <th>poAM</th>
              <th>poNoon</th>
              <th>poPM</th>
              <th>pdAM</th>
              <th>pdNoon</th>
              <th>pdPM</th>
            </tr>
            <tr
              v-for="item in data[n]"
              :key="item.id"
            >
            <td align="center">{{ item.id }}</td>
            <td align="center">{{ item.lot }}</td>
            <td align="center">{{ item.vesselType }}-{{ item.vesselId }}</td>
            <td align="center">{{ item.dryIce }}</td>
            <td align="center">{{ item.brixTemp }}</td>
            <td align="center">{{ item.poAM }}</td>
            <td align="center">{{ item.poNoon }}</td>
            <td align="center">{{ item.poPM }}</td>
            <td align="center">{{ item.pdAM }}</td>
            <td align="center">{{ item.pdNoon }}</td>
            <td align="center">{{ item.pdPM }}</td>
            </tr>
          </table>
          <v-btn @click="closeFerms(n)">CLOSE ALL {{n}} FERMS</v-btn>
          <br><br><br>
          <v-toolbar dense>
            <v-spacer></v-spacer>
            <v-toolbar-title>WorkOrders</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <br>
          <v-layout row>
            <v-flex xs5>
              <v-card>
                <v-card-title>PUNCH DOWNS</v-card-title>
                <table width="100%" v-if="Object.keys(workorders).length > 0">
                  <tr>
                    <th width="10%" align="center">ID</th>
                    <th align="center">LOT</th>
                    <th align="center">DRYICE</th>
                    <th align="center">BRIXTEMP</th>
                    <th align="center">VESSEL</th>
                    <th align="center">TIMESLOT</th>
                    <th align="center">STRENGTH</th>
                  </tr>
                  <tr
                    v-for="item in workorders[n].punchDowns"
                    :key="item.id">
                    <td align="center">{{ item.id }}</td>
                    <td align="center">{{ item.lot }}</td>
                    <td align="center">{{ item.dryIce }}</td>
                    <td align="center">{{ item.brixTemp }}</td>
                    <td align="center">{{ item.vesselType }}-{{ item.vesselId }}</td>
                    <td align="center">{{ item.timeSlot }}</td>
                    <td align="center">{{ item.strength }}</td>
                  </tr>
                </table>
              </v-card>
            </v-flex>
            <v-flex xs2></v-flex>
            <v-flex xs5>
              <v-card>
                <v-card-title>PUMP OVERS</v-card-title>
                <table width="100%" v-if="Object.keys(workorders).length > 0">
                  <tr>
                    <th width="10%" align="center">ID</th>
                    <th align="center">LOT</th>
                    <th align="center">DRYICE</th>
                    <th align="center">BRIXTEMP</th>
                    <th align="center">VESSEL</th>
                    <th align="center">TIMESLOT</th>
                    <th align="center">DURATION</th>
                  </tr>
                  <tr
                    v-for="item in workorders[n].pumpOvers"
                    :key="item.id">
                    <td align="center">{{ item.id }}</td>
                    <td align="center">{{ item.lot }}</td>
                    <td align="center">{{ item.dryIce }}</td>
                    <td align="center">{{ item.brixTemp }}</td>
                    <td align="center">{{ item.vesselType }}-{{ item.vesselId }}</td>
                    <td align="center">{{ item.timeSlot }}</td>
                    <td align="center">{{ item.duration }}</td>
                  </tr>
                </table>
              </v-card>
            </v-flex>
          </v-layout>
        </v-tab-item>
      </v-tabs>
  </v-container>
</template>

<script>
import axios from 'axios'
import async from 'async'
import myMixins from '../mixins/myMixins'

export default {
  data () {
    return {
      progress: false,
      active: null,
      theClients: [],
      data: {},
      workorders: {}
    }
  },
  created () {
    this.retrieveAllActiveFermentationProtocols()
  },
  computed: {
    vintage () {
      return this.$store.state.vintage
    },
    total () {
      var total = 0
      this.theClients.forEach(index => {
        total = total + this.data[index].length
      })
      return total
    }
  },
  mixins: [myMixins],
  watch: {
  },
  methods: {
    generatePDFs () {
      let url = process.env.VUE_APP_BACKEND+'workorders?printPDFs=true&fermprotocols=true'
      window.open(
        url,
        '_blank' // <- This is what makes it open in a new window.
      )
    },
    closeFerms (n) {
      let list = []
      this.data[n].forEach(item => {
        list.push({ id: item.id })
      })
      axios
        .put(process.env.VUE_APP_BACKEND+'fermprotocols?closeFermentationProtocols=true', list)
        .then(response => {
          this.retrieveAllActiveFermentationProtocols()
        })
    },
    sendFermProtocols () {
      var list = []
      let keys = Object.keys(this.data)
      keys.forEach(key => {
        this.data[key].forEach(fermprot => {
          list.push(fermprot)
        })
      })
      axios
        .post(process.env.VUE_APP_BACKEND+'fermprotocols?generateWorkOrders=true', list)
        .then(response => {
          this.retrieveAllActiveFermentationProtocols()
        })
    },
    retrieveAllActiveFermentationProtocols () {
      this.progress = true
      axios
        .get(process.env.VUE_APP_BACKEND+'fermprotocols')
        .then(response => {
          this.progress = false
          this.theClients = []
          var clientKeys = {}
          this.data = []
          response.data.data.forEach(fermprot => {
            let key = fermprot.clientCode
            if (!clientKeys[key]) {
              clientKeys[key] = true
              this.theClients.push(key)
            }
            if (!this.data[key]) {
              this.data[key]=[]
            }
            this.data[key].push(fermprot)
          })
          axios
            .get(process.env.VUE_APP_BACKEND+'workorders?autogenerated=YES')
            .then(response => {
              this.workorders = {}
              this.theClients.forEach(key => {
                this.workorders[key] = {
                  pumpOvers: [],
                  punchDowns: []
                }
              })
              response.data.data.forEach(item => {
                if (this.workorders[item.clientCode]) {
                  if (item.type === 'PUMP OVER') {
                    this.workorders[item.clientCode].pumpOvers.push(item)
                  } else {
                    this.workorders[item.clientCode].punchDowns.push(item)
                  }
                }
              })
            })
        })
    }
  }
}
</script>
<style>
.v-input {font-size: 12px;}
.v-list__tile__title {font-size: 12px;}
table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child, table.v-table thead td:not(:first-child),
 table.v-table thead th:first-child, table.v-table thead th:not(:first-child) {
    padding: 0 5px;
}
td {
  vertical-align: center;
}
</style>
